export * from '@primeuix/themes/material/tree';
export { default } from '@primeuix/themes/material/tree';
